import React, { useEffect, useState } from 'react';
import { LoginForm } from '../components/dashboard/LoginForm';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { checkAuth } from '../utils/api';
import { useLanguage } from '../store/languageContext';
import { Menu, X } from 'lucide-react';

const Dashboard = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const { setNavColor } = useLanguage();

    useEffect(() => {
        checkAuth().then(res => {
            if (res.data.loggedIn) {
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        });
        setNavColor('black');
    }, [navigate, setNavColor]);

    if (!loggedIn) return <LoginForm />;

    return (
        <div className="flex h-screen bg-gray-100 z-[1001] relative">
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/40 z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}
            <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
                <div className="p-4 pt-6 lg:pt-[44px] h-full overflow-y-auto">
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="text-xl font-bold">Dashboard</h2>
                        <button
                            onClick={() => setSidebarOpen(false)}
                            className="lg:hidden p-1 rounded hover:bg-gray-100"
                        >
                            <X className="size-5" />
                        </button>
                    </div>
                    <nav>
                        <ul className="space-y-1 sm:space-y-2">
                            <li>
                                <Link
                                    to="/dashboard/products"
                                    onClick={() => setSidebarOpen(false)}
                                    className="block py-2.5 px-4 text-gray-700 hover:bg-gray-200 rounded text-sm sm:text-base"
                                >
                                    Products
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/dashboard/brands"
                                    onClick={() => setSidebarOpen(false)}
                                    className="block py-2.5 px-4 text-gray-700 hover:bg-gray-200 rounded text-sm sm:text-base"
                                >
                                    Brands
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/dashboard/contact-requests"
                                    onClick={() => setSidebarOpen(false)}
                                    className="block py-2.5 px-4 text-gray-700 hover:bg-gray-200 rounded text-sm sm:text-base"
                                >
                                    Contact Requests
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
            <div className="flex-1 flex flex-col min-w-0">
                <div className="lg:hidden flex items-center gap-3 p-3 bg-white border-b sticky top-0 z-30">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="p-2 rounded hover:bg-gray-100"
                    >
                        <Menu className="size-5" />
                    </button>
                    <h2 className="text-lg font-semibold">Dashboard</h2>
                </div>
                <main className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8 pt-4 sm:pt-5 lg:pt-[20px] overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Dashboard;